import { createContext, useCallback, useMemo } from 'react'

import routes from 'core/routes'
import { api } from 'core/services'

import { IAccept, IContext, IGetUpdates } from './types'

const TermContext = createContext({} as IContext)

function TermProvider({ children }: any) {
  const getUpdates = useCallback(
    async (key: string, token: string): Promise<IGetUpdates> => {
      try {
        const headers = new Headers()
        headers.set('Content-Type', 'application/json')

        const response = await fetch(
          routes.api.terms({
            key,
            token,
            redirect_uri: `${process.env.REACT_APP_TOTY_URL}/${key}`,
          }),
          { headers },
        )

        const term = await response.json()

        return { term, url: response.url, updates: !term.accepted }
      } catch {
        return {
          url: '',
          updates: false,
        }
      }
    },
    [],
  )

  /**
   * @function accept
   *
   * @desc Accept terms.
   *
   * @param token
   */
  const accept = useCallback(
    async (key: string, token: string): Promise<IAccept> => {
      // TODO: Check how term flow works and how to fix it.
      const { data } = await api.post(
        `${routes.api.terms({
          key,
          token,
          redirect_uri: `${process.env.REACT_APP_TOTY_URL}/verification`,
        })}/user`,
        {},
        {
          headers: {
            'X-User-Token': token,
          },
        },
      )

      return { term: data }
    },
    [],
  )

  const props = useMemo(
    () => ({
      accept,
      getUpdates,
    }),
    [accept, getUpdates],
  )

  return <TermContext.Provider value={props}>{children}</TermContext.Provider>
}

export { TermProvider, TermContext }
